import { countriesTranslation } from '../constants';

const countriesTranslationCodes = countriesTranslation.map((el) => el.value);
export type LanguageCodeUpper = typeof countriesTranslationCodes[number];
export type LanguageCode = Lowercase<LanguageCodeUpper>;
